import { useState, useEffect, useCallback } from "react";
import { userService } from "../api/userService";
import { UserLimits } from "../types/userLimits";

export const useAnalysisUsage = (userId?: string) => {
    const [limits, setLimits] = useState<UserLimits | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchUsage = useCallback(async () => {
        if (!userId) return;

        setLoading(true);
        setError(null);

        try {
            const { getUserAnalysisUsage } = userService();
            const data = await getUserAnalysisUsage(userId);
            setLimits(data);
        } catch (err: any) {
            setError(err.message || "Failed to fetch analysis usage.");
            console.error("Error fetching analysis usage:", err);
        } finally {
            setLoading(false);
        }
    }, [userId]);

    useEffect(() => {
        fetchUsage();
    }, [fetchUsage]);

    return { limits, loading, error, refetch: fetchUsage };
};